import React, { useEffect, useState } from 'react';
import './PopupStartSipro.scss';
import { Button, notification } from 'antd';
import { useMarker } from '@bvt-features/genset/marker/hooks';
import { useAuth } from '@bvt-features/auth/hooks';
import { SiproStepZero } from '@bvt-features/mapana/sipro/component/SiproStepZero';
import { useSIPRO } from '@bvt-features/mapana/sipro/hook';
import { useFormik } from 'formik';
import { ID_SOURCE_CONSTANT } from '@bvt-shared/constant/ID_SOURCE_CONSTANT';
import { useNavigate } from 'react-router';
import { useStep } from '@bvt-features/mapp/step/hook';
import { useProject } from '@bvt-features/mapp/project/hooks/useProject';
import { usePlace } from '@bvt-features/mainmap/place/hooks/usePlace';
import _ from 'lodash';
import { featureFlags } from '@bvt-utils';

/**
 * @param {object} props
 * @param {() => {}} props.onRedirect
 * @param {() => {}} props.onClose
 * @param {JSX.Element} props.children
 * @param {object} props.marker
 * @param {string} props.marker.industry_name
 * @param {string} props.marker.group_name
 * @param {string} props.marker.category_name
 * @param {string} props.marker.category_icon
 * @param {string} props.marker.brand_name
 * @param {string} props.marker.poi_name
 * @param {string} props.marker.address
 * @param {string} props.marker.longitude
 * @param {string} props.marker.latitude
 * @param {string} props.marker.id_provinsi
 * @param {string} props.marker.nama_provinsi
 * @param {string} props.marker.id_kota
 * @param {string} props.marker.nama_kota
 * @param {string} props.marker.id_kecamatan
 * @param {string} props.marker.nama_kecamatan
 * @param {string} props.marker.id_desa
 * @param {string} props.marker.nama_desa
 */
export function PopupStartSipro(props) {
  const MARKER = useMarker();
  const AUTH = useAuth();
  const SIPRO = useSIPRO();
  const STEP = useStep();
  const NAVIGATE = useNavigate();
  const PROJECT = useProject();
  const PLACE = usePlace();
  const permissions = AUTH.state?.data?.user?.users_group?.permissions;
  const areaCoverage = permissions?.area_coverage;
  const provinceCoverage = (areaCoverage?.province || [])?.map(
    (province) => +province.id
  );
  const cityCoverage = (areaCoverage?.city || [])?.map((city) => +city.id);
  const [markerData, setMarkerData] = useState();
  const [openCreateProject, setOpenCreateProject] = useState(false);
  const [payloadProject, setPayloadProject] = useState();
  const mapanaAccess = AUTH.hasAccess('MAPANA');
  const siproAccess = AUTH.hasAccess('MAPANA.SIPRO');
  const [coordinateDetail, setCoordinateDetail] = useState({});
  const statusCoordinateDetail = PLACE.state.status_GET_DETAIL_FROM_POI;

  const FORMIK = useFormik({
    initialValues: {
      name: undefined,
    },
    onSubmit: () => {},
  });

  const saveMarker = () => {
    const properties = props.marker;
    const name = properties.poi_name;
    const maxLength = 50;
    const shortName = name.length > maxLength ? name.slice(0, maxLength) : name;
    const payloadMarker = {
      address: properties.address,
      id_desa: properties.id_desa ?? coordinateDetail?.id_desa,
      id_kota: properties.id_kota ?? coordinateDetail?.id_kota,
      id_kecamatan: properties.id_kecamatan ?? coordinateDetail?.id_kecamatan,
      id_provinsi: properties.id_provinsi ?? coordinateDetail?.id_provinsi,
      coordinate: [properties.longitude, properties.latitude],
      icon_color: '#046A65',
      icon_type: 'Marker8903',
      latitude: properties.latitude,
      longitude: properties.longitude,
      nama_desa: properties.nama_desa,
      nama_kecamatan: properties.nama_kecamatan,
      nama_kota: properties.nama_kota,
      nama_provinsi: properties.nama_provinsi,
      name: shortName,
      siteName: shortName,
    };
    MARKER.create(payloadMarker);
  };

  const saveProject = (value = {}) => {
    const data = { ...FORMIK.values, ...value };
    const payload = {
      id: null,
      name: data?.name || '',
      project_type: data?.project_type || '',
      process_id: null,
      id_source: ID_SOURCE_CONSTANT,
      administrative: {},
      markers: [],
      vehicleAndDataType: {
        vehicleOrwalking: {},
        radiusBasedOn: {},
        distanceOrtime: {},
      },
      poi: { selected: [] },
      parameter: { id: [] },
      density: {
        timeType: 'specific',
        isChecked: false,
        year: '',
        month: '',
        day: '',
        time: {
          min: '',
          max: '',
        },
        resultType: 'total',
      },
      analyze_result: {},
      id_step: data?.id_step,
      step_order: data?.step_order,
      history: {
        step_order: data?.step_order,
      },
    };
    setPayloadProject(payload);
  };

  const handleClick = () => {
    const properties = props.marker;
    PLACE.getCoordinateFromPOI({
      meta: {
        filter: {
          id_source: ID_SOURCE_CONSTANT,
          latitude: `${properties.latitude}`,
          longitude: `${properties.longitude}`,
        },
      },
    });
  };

  useEffect(() => {
    const detail = PLACE.state.coordinateDetailFromPOI;
    if (detail) {
      setCoordinateDetail(detail);
    }
  }, [PLACE.state.coordinateDetailFromPOI]);

  useEffect(() => {
    if (!_.isEmpty(coordinateDetail)) {
      if (
        !provinceCoverage.includes(coordinateDetail.id_provinsi) ||
        !cityCoverage.includes(coordinateDetail.id_kota)
      ) {
        notification.close('LOCATION');
        notification.open({
          key: 'LOCATION',
          message: 'Marker is out of range of the area coverage',
          placement: 'top',
          style: {
            zIndex: 99999999,
            backgroundColor: '#D0422F',
            borderRadius: '4px',
          },
          duration: 3,
          className: 'PoiSearch',
          top: '8.5rem',
        });
        setCoordinateDetail({});
        PLACE.resetCoordinateFromPOI();
        return;
      }
      PROJECT.generateProjectNameFromPOI();
    }
  }, [coordinateDetail]);

  useEffect(() => {
    if (MARKER.status.CREATE === 'SUCCESS') {
      const data = MARKER.state.new;
      setMarkerData({
        id: data.marker_id,
        IconColor: '#046A65',
        ...data,
      });
      PLACE.resetPlaceParams();
    }
  }, [MARKER.status.CREATE]);

  useEffect(() => {
    if (markerData) {
      const payload = { ...payloadProject, markers: [markerData] };
      SIPRO.saveProjectFromPOI(payload);
    }
  }, [markerData]);

  useEffect(() => {
    if (PROJECT.state.status_GENERATE_NAME_FROM_POI === 'SUCCESS') {
      FORMIK.setFieldValue('name', PROJECT.state.defaultName);
      setOpenCreateProject(true);
    }
  }, [PROJECT.state.status_GENERATE_NAME_FROM_POI]);

  useEffect(() => {
    const id = SIPRO.state?.formSaveProject?.id;
    if (SIPRO.state.status_POST_FROM_POI === 'SUCCESS' && id) {
      props?.onClose?.();
      setOpenCreateProject(false);
      props?.onRedirect?.();
      SIPRO.resetAll();
      PROJECT.resetState();
      MARKER.removeAll();
      MARKER.resetStatusAndMessage();
      STEP.setCurrentStep(3);
      SIPRO.setStep(3);
      PLACE.resetAll();
      NAVIGATE(`/app/map/map-analytic/site-profiling?step=3&project_id=${id}`);
    }
  }, [STEP.state.step, SIPRO.state.status_POST_FROM_POI]);

  return (
    <React.Fragment>
      <div className='PopupStartSipro__popup'>
        <div className='popup-detail'>{props.children}</div>
        {featureFlags.intelligence.adjPoiPopup ? (
          <div className='btn-wrapper'>
            <Button
              className='btn-wrapper-site'
              disabled={
                !mapanaAccess ||
                !siproAccess ||
                statusCoordinateDetail === 'LOADING'
              }
              onClick={handleClick}
            >
              Start Site Profiling
            </Button>
          </div>
        ) : null}
      </div>
      {openCreateProject && (
        <SiproStepZero
          errorMessage={
            SIPRO.state.status_POST_FROM_POI === 'FAILED' && SIPRO.state.message
          }
          isFailed={SIPRO.state.status_POST_FROM_POI === 'FAILED'}
          isLoading={
            SIPRO.state.status_POST_FROM_POI === 'LOADING' ||
            MARKER.status.CREATE === 'LOADING'
          }
          lastStep={SIPRO.state?.lastStep}
          onDismissError={() => SIPRO.resetStatus()}
          onNext={(v) => {
            saveMarker();
            saveProject({
              name: v?.name,
              project_type: v?.project_type,
              id_step: 5,
              step_order: 3,
            });
          }}
          onPrev={() => {
            setOpenCreateProject(false);
            setCoordinateDetail({});
            PLACE.resetCoordinateFromPOI();
            PROJECT.resetGenerateNameFromPOI();
          }}
          projectName={FORMIK.values.name}
          renameChecker={false}
        />
      )}
    </React.Fragment>
  );
}
